
<script>

export default {
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    openLink() {
      this.$http._get({
        url: '/index/Process/route'
      }).then(({ data }) => {
        window.location.replace(data);
      });
    }
  },
  mounted() {
    this.openLink();
  },
};
</script>
<style scoped>

</style>
